import React from "react";
import "./styles.css";

const Chart = ({ data, buybtn, sellbtn, handleClick }) => {
  function priceIndicator(name, price) {
    const avg_price_list = {
      weed: [100, 600],
      cocaine: [3000, 45000],
      heroine: [7000, 35000],
      acid: [1000, 3000],
      ludes: [8, 30],
      pcp: [1000, 2500]
    };
    let itemPrice = price;
    let item_name = name;
    if (itemPrice < avg_price_list[item_name][0]) {
      return "low";
    } else if (itemPrice > avg_price_list[item_name][1]) {
      return "high";
    } else return "avg";
  }
  return (
    <>
      <div className="price-chart">
        <table>
          <thead>
            <tr>
              <th className="item-name">Name</th>
              <th>Price($)</th>
              <th>Sell</th>
              <th>Qty</th>
              <th>Buy</th>
            </tr>
          </thead>
          <tbody>
            {data.items.map((i, index) => (
              <tr className="item" key={index}>
                <td
                  className="item-name"
                  onClick={(e) => handleClick(i.name, e)}
                >
                  {i.name.replace(/^\w/, (c) => c.toUpperCase())}
                </td>
                <td
                  className={priceIndicator(i.name, i.price)}
                  onClick={(e) => handleClick(i.name, e)}
                >
                  {i.price}
                </td>
                <td className="sell-btn" onClick={(e) => sellbtn(i.name, e)}>
                  {" "}
                  -{" "}
                </td>
                <td className="item-price">{i.qty}</td>
                <td className="buy-btn" onClick={(e) => buybtn(i.name, e)}>
                  {" "}
                  +{" "}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default Chart;
